import React from 'react';
export function OpeningHook() {
  return <section className="w-full bg-[#f8fafc] py-16 px-4" data-id="element-206" data-mp="2be3k9oouvq6g">
      <div className="max-w-4xl mx-auto" data-id="element-207" data-mp="1uxlxjvsgz7ns">
        <div className="border-l-4 border-[#fbbf24] pl-6 md:pl-8" data-id="element-208" data-mp="1uwkk5knze92w">
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed mb-4" data-id="element-209" data-mp="1gwjbhj1h5xcv">
            Vivir solo en Chile se convirtió en un lujo silencioso. Entras al
            Jumbo o al Lider por "tres cositas", sales con dos bolsas medianas y
            la cuenta marca $45.000. Miras la boleta y no entiendes en qué se
            fue el sueldo.
          </p>
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed mb-4" data-id="element-210" data-mp="x9lnvb17b35j">
            No es tu imaginación y no es solo la inflación.
          </p>
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed font-semibold" data-id="element-211" data-mp="1297yrdtk47b6">
            El sistema está diseñado para que la persona que vive sola pague más
            por gramo, desperdicie más comida y caiga en la trampa del ahorro
            falso de las etiquetas rojas.
          </p>
        </div>
      </div>
    </section>;
}